<template>
    <div :class="[{'dragover-active' : active.value}]" ref="dropzone" 
         @dragenter.prevent="setActive" @dragover.prevent="setActive" @dragleave.prevent="setInactive" @drop.prevent="onDrop">
        <slot :dropZoneActive="active"></slot>
    </div>
</template>

<script>
    import _ from 'lodash'

    // setActive и setInactive используют таймауты, так что когда вы перетаскиваете элемент на дочерний элемент,
    // срабатывающее событие dragleave не вызовет мерцания. Несколько мс должно быть много
    // время ожидания следующего события dragenter для сброса тайм-аута и возврата его в активное состояние.
    //https://github.com/joezimjs/vue-dd-uploader/blob/main/src/components/DropZone.vue

	export default {
        name: "drop-zone",

        props: ['name', 'value', 'files-dropped', 'dataId', 'accept'],

        $_veeValidate: {
            value() {
                console.info('$_veeValidate', this.selectedFile);
                return this.selectedFile;
            },
            name() {
                return this.name;
            }
        },

        watch: {
            value: function (newVal, oldVal) {
                if (newVal > 0) {
                    this.selectedFile = 1;
                } else {
                    this.selectedFile = null;
                }
            }
        },

        data() {
            return {
                events: ['dragenter', 'dragover', 'dragleave', 'drop'],
                inActiveTimeout: null,
                active: { value: false },
                selectedFile: null
            }
		},
		methods: {
            setActive() {
                this.active.value = true;
                clearTimeout(this.inActiveTimeout);
                //console.info('setActive');
            },

            setInactive() {
                this.inActiveTimeout = setTimeout(() => {
                    this.active.value = false;
                }, 50);
                //console.info('setInactive');
            },

            onDrop(e) {
                this.setInactive();
                this.$emit('files-dropped', { files: [...e.dataTransfer.files], id: this.dataId, accept: this.accept });
                //console.info('onDrop');
            },

            preventDefaults(e) {
                e.preventDefault();
            },
        },
        mounted() {
            let vm = this;
            vm.events.forEach((eventName) => {
                document.body.addEventListener(eventName, vm.preventDefaults);
            });
            if (vm.value > 0) {
                this.selectedFile = 1;
            }
        },
        destroyed() {
            let vm = this;
            vm.events.forEach((eventName) => {
                document.body.removeEventListener(eventName, vm.preventDefaults);
            });
        }
	}
</script>

<style scoped>
    .dragover-active {
        background: #ECEFF1;
    }
</style>


// WEBPACK FOOTER //
// Content/src/components/DropZone.vue